<template>
  <!-- <TopIconContainer >
    <img v-lazy="$store.getters.getUrl('Gold_popularImg')" />
  </TopIconContainer> -->
  <div class="container">
      <img class="icon" :src="iconUrl" v-if="iconUrl" />
    <img v-lazy="popularImg" alt="" />
  </div>
</template>

<script>
export default {
  name: "HotList",
  props: {
    iconUrl: {
      require: true,
    },
    popularImg: {
      require: true,
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  display: flex;
  flex-direction: column;
  img {
    width: 100%;
    margin-top: 25px;
  }
}
</style>
